import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import * as APIModels from "../../../../models";
import { DocumentRulesService } from "../../../../services/ClientService";

export type DocumentTypeRuleModalProps = {
    show: boolean;
    attorneyId: string;
    county?: string;
    division?: string;
    document: APIModels.Document;
    filingCode: string;
    filingComponent: string;
    securityType: string;
    ruleId?: string;
    portalIdentifier: string;
    onSave: () => void;
    onClose: () => void;
};

export default function DocumentTypeRuleModal({
    show,
    attorneyId,
    county,
    division,
    document,
    filingCode,
    filingComponent,
    securityType,
    ruleId,
    portalIdentifier,
    onSave,
    onClose,
}: DocumentTypeRuleModalProps) {
    const [rule, setRule] = useState({
        id: ruleId,
        attorneyID: attorneyId,
        county: county,
        division: division,
        filename: document.filename,
        documentType:
            portalIdentifier == "FL" ? document.documentType : filingCode,
        description: document.description ?? "",
        securityType: securityType ?? "",
        component: filingComponent ?? "",
    } as APIModels.DocumentTypeRule);

    useEffect(() => {
        setRule({
            id: ruleId,
            attorneyID: attorneyId,
            county: county,
            division: division,
            filename: document.filename,
            documentType:
                portalIdentifier == "FL" ? document.documentType : filingCode,
            component: filingComponent,
            description: document.description,
            securityType: securityType,
        });
    }, [show, attorneyId, county, division, document, ruleId]);

    const saveRule = () => {
        if (!rule.id || rule.id == APIModels.EmptyGuid) {
            DocumentRulesService.add({
                body: {
                    ...rule,
                    active: true,
                },
            }).then(
                (resp) => {
                    onSave();
                },
                (error) => {
                    console.log(error);
                }
            );
        } else {
            DocumentRulesService.update({
                id: rule?.id ?? "",
                body: rule,
            }).then(
                (resp) => {
                    onSave();
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Document Type Rule
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>County</label>
                        <input
                            className="form-control"
                            id="docTypeRuleCounty"
                            type="text"
                            defaultValue={rule.county}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    county: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>Division</label>
                        <input
                            className="form-control"
                            id="docTypeRuleDivision"
                            type="text"
                            defaultValue={rule.division}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    division: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Filename</label>
                        <input
                            className="form-control"
                            id="docTypeRuleFilename"
                            type="text"
                            defaultValue={rule.filename}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    filename: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>File Text</label>
                        <input
                            className="form-control"
                            id="docTypeRuleFileText"
                            type="text"
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    fileText: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-3">
                        <label>Min Amount</label>
                        <input
                            className="form-control"
                            id="docTypeRuleMinAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    minAmount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-3">
                        <label>Max Amount</label>
                        <input
                            className="form-control"
                            id="docTypeRuleMaxAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    maxAmount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-3">
                        <label>New Cases?</label>
                        &nbsp;
                        <input
                            className="form-checkbox"
                            id="docTypeRuleNewCases"
                            style={{ verticalAlign: "middle" }}
                            type="checkbox"
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    newCases: event.currentTarget.checked,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    {portalIdentifier != "FL" ? (
                        <>
                            <div className="col-sm-6 mb-2">
                                <label>Filing Code</label>
                                <input
                                    className="form-control"
                                    id="docTypeRuleDocType"
                                    type="text"
                                    defaultValue={rule.documentType}
                                    onChange={(event) =>
                                        setRule({
                                            ...rule,
                                            documentType:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="col-sm-6 mb-2">
                                <label>Filing Component</label>
                                <input
                                    className="form-control"
                                    id="docTypeRuleDocType"
                                    type="text"
                                    defaultValue={rule.component}
                                    onChange={(event) =>
                                        setRule({
                                            ...rule,
                                            component:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="col-sm-6 mb-2">
                                <label>Security Type</label>
                                <input
                                    className="form-control"
                                    id="docTypeRuleDocType"
                                    type="text"
                                    defaultValue={rule.securityType}
                                    onChange={(event) =>
                                        setRule({
                                            ...rule,
                                            securityType:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="col-sm-6 mb-2">
                                <label>Description</label>
                                <input
                                    className="form-control"
                                    id="docTypeRuleDocType"
                                    type="text"
                                    defaultValue={rule.description}
                                    onChange={(event) =>
                                        setRule({
                                            ...rule,
                                            description:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="col-sm-12">
                                <label>Document Type</label>
                                <input
                                    className="form-control"
                                    id="docTypeRuleDocType"
                                    type="text"
                                    defaultValue={rule.documentType}
                                    onChange={(event) =>
                                        setRule({
                                            ...rule,
                                            documentType:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </>
                    )}
                </div>
                <div className="row form-group  m-2">
                    <div className="col-sm-12">
                        <label>Valid Until</label>
                        <input
                            className="form-control"
                            id="docTypeRuleUntil"
                            type="date"
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    validUntil:
                                        event.currentTarget.valueAsDate === null
                                            ? undefined
                                            : event.currentTarget.valueAsDate,
                                })
                            }
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={saveRule}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
}
